/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import ds from 'designsystem';
import Fade from 'react-reveal/Fade';
import { inject, observer } from 'mobx-react';
import { ProductSlide as ProductSlideModel } from 'models';
import { media } from 'designsystem/index';
import { FADE_VALUES } from 'animations/Animations';
import Parser from 'blocks/Parser/Parser';
import StyledLink from 'blocks/StyledLink';
import BottomImage from './BottomImage';

const ProductCardBox = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 520px;
  background-color: ${ds.brand('background')};
  overflow: hidden;

  ${media.tablet`
    height: 550px;
  `}

  ${media.desktop`
    width: 95%;
    max-width: 431px;
  `}
`;

const StyledLinkForImage = styled(StyledLink)`
  display: block;
  margin: ${ds.get('metrics.l')} ${ds.get('metrics.l')};
  &:hover + * > ${BottomImage}, &:hover > ${BottomImage} {
    bottom: 0;
  }
`;

const MarginBox = styled.div`
  ${media.tablet`
    margin-right: ${ds.get('metrics.s')};
  `}

  ${media.desktop`
    margin-right: 0;
  `}
`;

ProductCardBox.BottomImage = BottomImage;

@inject('windowStore')
@observer
export default class ProductSlide extends Component {
  render() {
    const {
      featureCard: {
        content,
        bottomImage,
        slug,
      },
      index,
      windowStore,
    } = this.props;

    return (
      <Fade
        bottom
        distance={`${FADE_VALUES.BOX.LARGE}`}
        delay={windowStore.isOnMobile ? FADE_VALUES.DELAY.SMALL : FADE_VALUES.DELAY.SMALL * index}
      >
        <MarginBox index={index}>
          <ProductCardBox>
            <StyledLinkForImage to={slug}>
              <Parser htmlBody={content} />
            </StyledLinkForImage>
            <StyledLinkForImage to={slug} onClick={e => e.preventDefault()}>
              <BottomImage src={windowStore.adjustImageSize(bottomImage)} />
            </StyledLinkForImage>
          </ProductCardBox>
        </MarginBox>
      </Fade>
    );
  }
}

ProductSlide.propTypes = {
  featureCard: PropTypes.instanceOf(ProductSlideModel).isRequired,
  index: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/ProductSlider/ProductSlide/index.jsx